export const APIROUTES = {
    AUTH: {
        LOGIN: 'auth/login',
        REGISTER_DEVICE_ID_FOR_GUEST: 'auth/guest/register',
        FIREBASE_AUTH: 'auth/firebase/standalone',
        LOGOUT: 'auth/logout',
        ME: 'auth/me',
        PASSWORD: {
            FORGOT: 'forgot-password',
            UPDATE: 'auth/update-password',
            RESET: 'reset-password'
        },
        REFRESH: 'auth/refresh',
        CHECKEMAIL: 'auth/check-email',

        // link to PMD / Organization
        LINK_TO_ORGANIZATION : 'auth/link-user-to-organization',
        LINK_TO_PMD : 'auth/link-user-to-pmd',
        USER_TOTAL_HOUR_PER_MONTH : 'auth/total-hour-of-prayer',
        ORG_TOTAL_HOUR_PER_MONTH : 'auth/organization/total-hour-of-prayer'
    },
    PUSHNOTIFICATION: {
        REGISTER: 'auth/register-firebase-token/', // {user} POST {token}
    },
    LOCATION : {
        COUNTRIES: 'location/countries/', // {offset}
        CITIES: 'location/cities/', //{countryCode}/{offset}
        COUNTRIES_WITH_USERS: 'location/countries-with-users/', // {offset}
        CITIES_WITH_USERS: 'location/cities-with-users/', // {countryCode}/{offset}
        COUNTRY_CODE: 'location/countries', //{code}
    },
    MASTERDATA: {
        TYPES: 'masterdata',
        LANGUAGES: 'masterdata/preferred_languages',
        USERS: 'masterdata/user_types',
        ORGANIZATIONS: 'masterdata/organization_types',
        
    },
    PROFILE: {
        CREATE: 'profile',
        GET: (user: number) => `profile/${user}`, 
        UPDATE: (user: number) => `profile/${user}`,
        PROFILE: (user: number) => `profile/${user}/profile-picture`,
        CHANGELANGUAGE: `profile/language/update`, // POST {language} // change profil language,
        DEACTIVATEACCOUNT: 'profile/deactivate-account'
    },
    PMD: {
        PROFILE: {
            CREATE: 'pmd-profile',
            GET: (id: number) => `pmd-profile/${id}`, 
            PRESELECT: (id: number) => `select-pmd/${id}`, // get pmd without authentification
            UPDATE: (id: number) => `pmd-profile/${id}`,
            UPDATESTATUS: (pmdId: number, status: string) => `pmd-profile/${pmdId}/update/${status}`,
        },
        LIST: 'pmd-list',
    },
    ORGANIZATION: {
        PROFILE: {
            CREATE: 'organization-profile',
            GET: (id: number) => `organization-profile/${id}`,
            PRESELCT: (id: number) => `select-organization/${id}`, // get organization without authentification
            UPDATE: (id: number) => `organization-profile/${id}`
        },
        LIST: 'organization-list',
        MEMBERS: (organizationId: number) => `summary/${organizationId}/members`,
        USERLIST: 'empower/user/list',
    },
    PRAYERSCHEDULE: {
        CREATE: {
            // ORGANIZATION: 'prayer-schedule/organization',
            ORGANIZATION: 'organization-schedule-prayer',
            // INDIVIDUAL: 'prayer-schedule/individual',
            // ALLOCATEDATEHOUR: 'prayer-schedule/allocateDateHour/', //{userId}
            JOINORGANIZATIONDATE: 'schedule-user-prayer/join-organization-date', //{userId}
            LEAVEORGANIZATIONDATE: 'schedule-user-prayer/leave-organization-date', //{userId}
            USER_INDIVIDUAL: 'schedule-user-prayer', // POST
            JOINMYOWNDATE: 'schedule-user-prayer/join-myown-date', //{userId}
        },
        GET: 'prayer-schedule/',
        GETALLORGANIZATION: 'organization-schedule-prayer/allorganization/',
        GET_ORGANIZATION_SCHEDULE: 'organization-schedule-prayer/',
        // GET_USER_SELECTED_DATE : (userId: number) => `schedule-user-prayer/${userId}/information/selected-date`,
        GET_USER_SELECTED_DATE : (orgId: number,userId: number) => `schedule-user-prayer/${orgId}/${userId}/information/selected-date`,
        // ORG_TIMESPAN: 'prayer-schedule/organization/details/timespan',
        ORG_TIMESPAN: 'organization-schedule-prayer/organization/details/date',
        // TIMESPAN: 'prayer-schedule/timespan',
        // ALLOCATEDATEHOURDETAILS: (userId: number) => `prayer-schedule/allocateDateHour/${userId}/details`,
        GET_INDIVIDUALS_OWN_DATE : 'schedule-user-prayer/',
        GET_NEXT_PRAYER_DAY : 'prayer/list-some-next-prayer-day',
        GET_ORGANIZATION_PRAYER_SCHEDULE : (organizationID : number) => `organization-schedule-prayer/${organizationID}/information/selected-date`,
        DELETE_ORGANIZATION_PRAYER_SCHEDULE : (organizationID : number) => `organization-schedule-prayer/delete-prayer-schedule/${organizationID}`,
        USER_PRAYER_TIME_LIST : 'schedule-user-prayer/check-user-prayer-time-to-delete', // GET
        DELETE_USER_PRAYER_TIME : (user_id : number) => `schedule-user-prayer/${user_id}/delete-user-prayer-time`, // DELETE
        
    },
    PRAYERBOARD: {
        LIST: 'prayerboard/list/', // GET {action} seen or unseen,
        LISTAPPROVED: 'prayerboard/management', // GET ,
        LISTANY: 'prayerboard', // GET
        CREATE: 'prayerboard', // POST
        PERFORM_ACTION: (prayerId: number, action: string) => `prayerboard/handleprayer/${prayerId}/${action}`,
        DETAILS: 'prayerboard/', // GET {prayerboard}
        UPDATE: 'prayerboard/', // {prayerboard} PUT
        PENDING: 'prayerboard/pending/list',
        APPROVE: (prayerboard: number) => `prayerboard/pending/${prayerboard}/approve/update`,
        REJECT: (prayerboard: number) => `prayerboard/pending/${prayerboard}/reject/update`,
        COMMENTS: {
            ADD: (prayerboard: number) => `prayerboard/${prayerboard}/comment`, // POST {content}
            LIST: (prayerboard: number) => `prayerboard/${prayerboard}/comment`, // GET
            UPDATE: (prayerboard: number, prayercardcomment: number) => `prayerboard/${prayerboard}/comment/${prayercardcomment}`, // PATCH {content}
            REMOVE: (prayerboard: number, prayercardcomment: number) => `prayerboard/${prayerboard}/comment/${prayercardcomment}`, // DELETE
            REPORT: (prayerboard: number) => `prayerboard/${prayerboard}/comment/report`, // POST {"reason", "prayer_board_comment_id"}
            LIST_REPORTED: (prayerboard: number) => `prayerboard/${prayerboard}/comment/report`, // GET
        }
    },
    GLOBALPRAYER: {
        PRAYER: {
            PRAYERTIME: 'prayer/next-prayer-day',
            PRAYACTION: 'prayer/logprayer/', // {action = start|stop} POST {date}
        },
        CARDS: {
            LIST: 'prayercard',
            CREATE: 'prayercard', // POST
            GET: 'prayercard/', // {prayercard}
            UPDATE: 'prayercard/', // {prayercard} PUT
            UPDATE_STATUS: (prayercard: number) => `prayercard/${prayercard}/status/update`
        },
        PRAYERROOM: {
            LIST: 'prayernew',
            CREATE: 'prayernew', // POST {content}
            GET: 'prayernew/', // {prayernew}
            UPDATE: 'prayernew/', // {prayernew} PUT {content}
            DELETE: 'prayernew/', // {prayernew} DELETE
            REACT: 'prayernew/handleprayer/', // {prayernew}/{action} POST
            REPORT: 'prayernew/report/', // {prayernew} POST {report_reason}
            APPROVEREPORT: (prayernew: number) => `prayernew/handleprayer/${prayernew}/approved`, // {prayernew}/{action} POST 
            ARCHIVE : (idPrayerNew : number) => `prayernew/${idPrayerNew}/archive`, // POST
            CHECK_BAD_WORDS: 'prayernew/check-bad-words', // POST {content}
        },
        VIDEOS: {
            LIST: 'prayervideo',
            CREATE: 'prayervideo', // POST
            GET: 'prayervideo/', // {prayervideo}
            UPDATE: 'prayervideo/', // {prayervideo} PUT
            DETAILS: 'prayervideo/', // GET {prayervideo}
            UPDATE_STATUS: (prayervideo: number, status: string) => `prayervideo/${prayervideo}/update/${status}`
        },
        JOURNAL: {
            LIST: 'prayerjournal',
            CREATE: 'prayerjournal', // POST {content}
            UPDATE: 'prayerjournal/', // {prayerjournal} PUT {content}
            DELETE: 'prayerjournal/', // {prayerjournal} DELETE
        },
        LEARN_MORE : {
            GET_LEARN_MORE_CONTENT : 'superadmin/learn-more', // GET
        }
    },
    PRAYERREPORT: {
        USER: {
            COVERED: 'report/user/prayer-covered'
        },
        ORGANIZATION: {
            COVERED: 'report/organization/hour-covered',
            SUCCESSPRAYER: 'report/organization/success-prayer',
            GETPRAYERBYMONTH: (organizationId: number) => `prayer-schedule/${organizationId}`,
            GETORGANIZATIONPRAYERBYMONTH: (organizationId: number) => `organization-schedule-prayer/${organizationId}`,// organization-schedule-prayer // new end point
            GENERATE_PDF : 'report/organization/generate-pdf'
        },
        CITY: {
            REPORT: `report/city-director`
        },
        GLOBAL: {
            REPORT: `report/global-director`,
            GENERATE_PDF : 'report/global-director/generate-pdf', // this.invoiceDownloadURL = APIENDPOINT.INVOICE.DOWNLOAD_INVOICE;
            GENERATE_CSV : 'report/global-report/generate-csv' 
        },
        PMD: {
            REPORT: 'report/pmd/', // GET {pmd} QUERY {month, year}
            REPORT_LOCATION: (pmd: number) => `report/pmd/locations/${pmd}`,
            REPORT_DATA: (pmd: number) => `report/pmd/${pmd}`,
            GENERATE_PDF : 'report/pmd/generate-pdf' // this.invoiceDownloadURL = APIENDPOINT.INVOICE.DOWNLOAD_INVOICE;
        }
    },
    EMPOWERMENT: {
        PERMISSIONS: 'rolepermission/permissions',
        ROLES: 'rolepermission/roles',
        FILTEREDROLES: 'rolepermission/filtered-roles',
        PERMISSIONSBYROLE: (role: number) => `rolepermission/permissions/${role}`,
        ROLEBYPERMISSION: (permission: number) => `rolepermission/roles/${permission}`,
        USERROLE: 'empower/user',
        USERPERMISSION: 'empower/user/permissions',
        SEARCHUSER: 'empower/user/search', // POST {name}
        ACTIVITIES : 'rolepermission/activities', // GET,
        REVOKEUSERROLE : 'empower/user/revoke'
    },
    SUPPORT: {
        LIST: 'support/list/', // support/list/{offset}/{user?}
        CREATE: 'support/create/', // support/create/{user}
        DETAILS: 'support/details/', // support/details/{support}/{user?}
        LOAD_MESSAGES: 'support/messages/', // support/messages/{support}/{offset?}
        SEND_MESSAGE: 'support/message/', // support/message/{user}/{support}
        MARK_AS: 'support/mark_as/', // support/mark_as/{support}
    },

    // LOCALIZATION - BACKOFFICE
    LANGUAGE: {
        LOAD: 'language/load/', // {language}
        LOADALL: 'language/get',
        GETLIST: 'language/list', // {language?}
        NEW: 'language/create', // POST {name, code}
        SAVE: 'language/save/', // {language} POST {translations}
        PUBLISH: 'language/publish/', // {language} PUT
        UNPUBLISH: 'language/unpublish/', // {language} DELETE
    },

    // PRAYER CARD
    PRAYERCARD: {
        LIST: 'prayercard', // GET {action} seen or unseen,
        CREATE: 'prayercard', // POST
        // PERFORM_ACTION: (prayerId: number, action: string) => `prayerboard/handleprayer/${prayerId}/${action}`,
        // DETAILS: 'prayerboard/', // GET {prayerboard}
        UPDATE: 'prayercard/', // {prayerboard} PUT
    },
    INVITE: {
        MEMBER: 'invite-member/' // /{type}/{id}
    },

    // SUPERADMIN DASHBOARD
    SUPERADMIN: {
        STATESDETAILS: 'superadmin/stats-details', // GET
        BLESS_DAY_TEMPLATE: {
            LIST: 'superadmin/bless-day-template', // GET
            CREATE: 'superadmin/bless-day-template', // POST
            UPDATE: (id: number) => `superadmin/bless-day-template/${id}`, // PUT
            DELETE: (id: number) => `superadmin/bless-day-template/${id}`, // DELETE
            BULK_DELETE: 'superadmin/bless-day-template', // DELETE
        },
        PRAYFORALLSTATS : 'superadmin/pray-for-all-stats', // GET
        REGISTRATIONSTATS : 'superadmin/registration-stats', // GET
        LISTNEWCHURCH: 'superadmin/new-organization-list', // GET
        LISTNEWPMD: 'superadmin/new-pmd-list', // GET
        SUPPORTTICKETLOGS: 'superadmin/support-ticket-logs', // GET,
        COMMUNICATIONCENTERMAIL: 'superadmin/communication-center/sendmailtoall', // POST
        COMMUNICATIONCENTERNOTIFICATION: 'superadmin/communication-center/notifyall', // POST
        PMDDETAILS: (pmd: number) => `superadmin/pmddetails/${pmd}`, // GET
        ORGANIZATIONDETAILS: (organization: number) => `superadmin/organizationdetails/${organization}`,
        USERROLES: (role: number)  =>`rolepermission/user-roles/${role}`,
        COMMUNICATIONCENTER_NOFITYACCOUNTHOLDER: 'superadmin/communication-center/notifyAccountHolder',
        COMMUNICATIONCENTER_MAILACCOUNTHOLDER: 'superadmin/communication-center/mailAccountHolder',
        COMMUNICATIONCENTER_CORRESPONDANCE: 'superadmin/communication-center/correspondance',
        COMMUNICATIONCENTER_NOTIFICATION: 'superadmin/communication-center/notification',
        COMMUNICATIONCENTER_MAIL: 'superadmin/communication-center/mail',
        COMMUNICATIONCENTER_PMDMAIL: 'superadmin/communication-center/pmd_mail',
        COMMUNICATIONCENTER_PMDNOTIFICATION: 'superadmin/communication-center/pmd_notification',
        COMMUNICATIONCENTER_ALLPMD: 'pmd-profile/allpmd/pmds',

        // PLAN
        GLOBAL_PRAYER_ROOM_CREATE_PLAN : 'global_prayer_room/superadmin/create_plan', // POST
        GLOBAL_PRAYER_ROOM_LIST_PLAN : 'global_prayer_room/superadmin/subscription_plan', // GET 
        GLOBAL_PRAYER_ROOM_UPDATE_PLAN : (id : number) => `global_prayer_room/superadmin/update_subrscription_plan/${id}`, // PUT 

        // USER INFO
        ORGANIZATION_LEADERS : (orgID : number) =>  `superadmin/organization-leader/${orgID}`, // GET

        // COUNTRY
        NATION : 'superadmin/nations', // GET
        COUNTRY_DETAILS : (countryCode : string) => `superadmin/country-details/${countryCode}`, // GET

        ORGANIZATION_BY_CITY : (cityId : number) => `superadmin/organization-by-city/${cityId}`,
        INDIVIDUAL_BY_CITY : (cityId : number) => `superadmin/individual-by-city/${cityId}`,

        // CITY
        CITY : 'superadmin/cities', // GET

        // ALL ORGANIZATION
        ALL_ORGANIZATION : 'superadmin/all-organization', // GET
        ALL_INDIVIDUAL : 'superadmin/all-individuals', // GET

        ORGANIZATION_GENERATE_EXCEL : 'superadmin/all-organization/generate-csv', // GET
        INDIVIDUAL_GENERATE_EXCEL : 'superadmin/all-individuals/generate-csv',

        // PRAY FOR ALL REPORT
        PRAY_FOR_ALL_PRAYER_REPORT : 'superadmin/prayer-report/pray-for-all-summary', // GET
        PRAY_FOR_ALL_NEW_USERS_REPORT : 'superadmin/prayer-report/pray-for-all-new-users', // GET
        PRAY_FOR_ALL_REPORT_DETAILS : (parameter : string) => `superadmin/prayer-report/pray-for-all/${parameter}`, // GET
        PRAY_FOR_ALL_REPORT_DETAILS_PMD : (pmdId : number) => `superadmin/prayer-report/pray-for-all/details/pmd/${pmdId}`, // GET

        // PMD DETAILS (member and organization)
        PRAY_FOR_ALL_REPORT_PMD_INDIVIDUAL : (pmdId : number) => `superadmin/prayer-report/pray-for-all/pmd/members/${pmdId}`, // GET
        PRAY_FOR_ALL_REPORT_PMD_ORGANIZATION : (pmdId : number) => `superadmin/prayer-report/pray-for-all/pmd/organizations/${pmdId}`, // GET

        // 24/7 Prayer Report - Details
        GLOBAL_PRAYER_REPORT_DETAILS : (date : string) => `superadmin/prayer-report/global-prayer-report-details/${date}`, // GET

        // REPORT EXPORTS
        PRAY_FOR_ALL_REPORT_EXPORT : 'superadmin/prayer-report/pray-for-all-summary/export', // GET
        NATIONAL_REPORT_PDF : 'superadmin/prayer-report/national/generate-pdf', // GET
        NATIONAL_CHURCH_CONTACTS : 'superadmin/prayer-report/national/church-contacts', // GET

        // TARGET NATION
        DASHBOARD_TARGET_NATION : 'superadmin/dashboard/target-nations', // GET
        // LEARN MORE MODULE
        GET_LEARN_MORE_CONTENT : 'superadmin/learn-more', // GET
        UPDATE_LEARN_MORE_CONTENT : `superadmin/learn-more/update`, // PUT
        ADD_LEARN_MORE_CONTENT : 'superadmin/learn-more/create', // POST
        ARCHIVE_LEARN_MORE_CONTENT : (id : number) => `superadmin/learn-more/${id}/archive`, // PUT
        DELETE_LEARN_MORE_CONTENT : (id : number) => `superadmin/learn-more/${id}`, // DELETE

        // CITY SUCCESS RATE
        DASHBOARD_SUCCESS_RATE : 'superadmin/dashboard/success-rate', // GET
        DASHBOARD_GLOBAL_PRAYED_TIME : 'superadmin/dashboard/global-prayed-time', // GET

        // COMMUNICATION WITH DONORS (SEND EMAIL)
        COMMUNICATIONCENTER_SEND_EMAIL_TO_DONORS : 'superadmin/communication-center/sendmailtousers', // POST

        // ORGANIZATION
        UPDATE_ORGANIZATION_STATUS : (orgId : number) => `superadmin/organization/update-organization-status/${orgId}` // PUT
    }, 

    // VIP
    VIP: {
        VIP_RELATIONSHIP : 'relationship',
        VIP_AVATAR : 'avatar',
        VIP_PERSON : 'prayforall_vip_persons', // POST/GET 
        VIP_PERSON_BY_ID : (id: number) => `prayforall_vip_persons/${id}`,
        VIP_REORDER_LIST : 'prayforall_vip_persons/reorder', // POST (from and to)
        VIP_UPDATE_SALVATION : (id: number) => `prayforall_vip_persons/${id}/salvation` // PUT
    },

    // FRIEND'S SECTION
    FRIEND_SECTION : {
        FRIEND_REQUEST : 'prayforall/friend-request/search', // GET
        SEND_FRIEND_REQUEST : (id: number) => `prayforall/friend-request/${id}`, // POST
        LIST_NEW_REQUEST_FRIEND : 'prayforall/friend-request', //GET
        LIST_FRIENDS : 'prayforall/friends/search', // GET (USER FRIEND)
        NEW_FRIEND_REQUEST_DETAILS : (request_user_id: number) => `prayforall/friend-request/${request_user_id}/show`, // GET
        FRIEND_REQUEST_ACCEPT : (id: number) => `prayforall/friend-request/${id}/approve`, // GET
        FRIEND_REQUEST_DECLINE : (id : number) => `prayforall/friend-request/${id}/reject`, // GET
        FRIEND_DETAILS : (id : number) => `prayforall/friends/${id}`, // GET
        FRIENDS_STATISTICS : 'prayforall/user/statistics/', // GET
        FRIEND_FRIENDS_ENCOURAGEMENT : 'prayforall/encouragement/list/', // GET
        FRIEND_LIKE_ENCOURAGEMENT : 'prayforall/encouragement/like/', // POST
        FRIEND_UNLIKE_ENCOURAGEMENT : 'prayforall/encouragement/unlike/', // POST
        FRIEND_CREATE_ENCOURAGEMENT : 'prayforall/encouragement', // POST
        UNFRIEND_REQUEST : 'prayforall/friends/unfriend/', // DELETE
        FRIENDS_FLOW : 'prayforall/friends/all/search' // GET
    },

    // ALARM - TOP BANNER
    ALARM : {
        SET_DAILY_ALARM : 'prayforall/set-daily-alarm',  // POST
        GET_DAILY_ALARM : 'prayforall/get-daily-alarm', // GET
    },

    // TAB SECTION - PRAYER LOGS - BADGES - ENCOURAGEMENTS
    BADGE : {
        GET_BADGE_USER : (user_id : number) => `prayforall/badge/list/${user_id}` // GET
    },

    ENCOURAGEMET : {
        GET_USER_ENCOURAGEMENT : 'prayforall/encouragement/list/', // GET
        LIKE_ENCOURAGEMENT : 'prayforall/encouragement/like/', // POST
        UNLIKE_ENCOURAGEMENT : 'prayforall/encouragement/unlike/', // POST
        REPLY_ENCOURAGEMENT : (id: number) => `prayforall/encouragement/reply/${id}`, // POST
        LOAD_MORE_REPLIES_ENCOURAGEMENT : (id: number) => `prayforall/encouragement/reply/more/${id}`, // GET
    },

    // PRAYER_LOG : {
    //     GET_PRAYER_LOG : 'prayforall/prayer-log' // GET
    // },

    PRAY_FOR_ALL : {
        START_PRAYER : 'prayforall/prayer/start-prayer', // POST
        END_PRAYER : 'prayforall/prayer/end-prayer', // POST
        LEARN_MORE : {
            GET_LEARN_MORE_CONTENT : 'superadmin/learn-more', // GET
        }
    },

    BLESS : {
        GLOBAL_COUNT : 'prayforall/global-count/total-bless-mission-count', // GET
        CREATE_BLESS_MISSION : 'prayforall/blessing-mission/create-bless-mission', // POST
        LIST_CURRENT_BLESS : 'prayforall/blessing-mission/list-of-current-bless-mission', // GET
        LIST_COMPLETED_BLESS : 'prayforall/blessing-mission/list-of-completed-bless-mission', // GET
        COMPLETE_MISSION : 'prayforall/blessing-mission/make-bless-mission-completed/', // POST
        DELETE_MISSION : 'prayforall/blessing-mission/delete-mission/', // DELETE
        COUNT_CURRENT_BLESS : 'prayforall/blessing-mission/count-current-mission', // GET
        COUNT_COMPLETED_BLESS : 'prayforall/blessing-mission/count-completed-mission' // GET
    },

    ACTIVITIES : {
        GET_ACTIVITIES : 'prayforall/activities-slider', // GET
        GET_GLOBAL_UPDATES : 'prayforall/global-updates', // GET
        UPDATE_GLOBAL_UPDATES : (id: number) => `prayforall/global-updates/update/${id}`, // PUT
        UPDATE_TESTIMONY_GLOBAL_UPDATES : (id: number) => `prayforall/global-updates/update/testimony/${id}`, // PUT
    },

    NOTIFICATION : {
        GET_NOTIFICATION_DOT : 'prayforall/notification-dot' // GET
    },

    PRAY_FOR_ALL_REPORT : {
        ORGANIZATION_REPORT : "prayforall/report/organization/", // GET
        PMD_SUMMARY_REPORT : "prayforall/report/pmd-summary/", // GET
        PMD_ORGANIZATION_REPORT : "prayforall/report/pmd-organizations/", // GET
        PMD_INVIDIVUAL_REPORT : "prayforall/report/pmd-individuals/", // GET
        ORGANIZATION_REPORT_GENERATE_PDF : (organization_id : number) => `prayforall/report/organization/${organization_id}/generate-pdf`, // GET
        PMD_ORGANIZATION_REPORT_GENERATE_PDF : (pmd_id : number) => `prayforall/report/pmd/${pmd_id}/organization/generate-pdf`, // GET
        PMD_INDIVIDUAL_REPORT_GENERATE_PDF : (pmd_id : number) => `prayforall/report/pmd/${pmd_id}/individual/generate-pdf`, // GET
    },

    GLOBAL_PRAYER_ROOM : {
        // Top Banner
        NEXT_ROOM_OPEN: 'global_prayer_room/next_prayer_room_open', // GET
        TOP_BANNER_STATS: 'global_prayer_room/statistics', // GET

        // Plans 
        LIST_PLAN : 'global_prayer_room/list/subscription-plan', // GET
        LIST_PLAN_BY_USER : 'global_prayer_room/list-plan-by-user', // GET
        LISTPERSONAL_PLANS: 'global_prayer_room/list_subscription_plan/personel', // GET
        LISTCHURCH_PLANS: 'global_prayer_room/list_subscription_plan/personel', // GET
        SELECT_PERSONAL_PLAN: 'global_prayer_room/subscription-plan/personel', // POST
        PRODUCT_BY_PLAN_ID : (planID : string) => `global_prayer_room/subscription-plan/${planID}`, // GET
        USER_PLAN : 'global_prayer_room/subscription/user-plan', // GET
        SELECT_PLAN : 'global_prayer_room/select/subscription-plan', // GET
        UPDATE_USER_PLAN_STATUS : (planID : number, is_personal : number) => `global_prayer_room/subscription/update-user-plan/${planID}/${is_personal}`, // PUT
        

        // For meeting
        CONNECTED_USER : 'global_prayer_room/connected-user', // POST
        OPEN_ROOM : 'global_prayer_room/meeting/open_room/', // {roomId}
        CLOSE_ROOM : 'global_prayer_room/meeting/close_room/', // {roomId}
        JOIN_ROOM : 'global_prayer_room/user/join-room', // POST
        GET_ROOM_BY_ID : 'global_prayer_room/get-room-info-by-id', // GET
        GET_USER_CONNECTED_BY_ROOM : 'global_prayer_room/users/get-all-user-by-room', // GET
        USER_STATUS : 'global_prayer_room/user-status/by-room/', // {roomID} GET
        UPDATE_USER_STATUS : 'global_prayer_room/update-user-room', // PUT
        GET_USER_BY_ROOM_AND_PEER : 'global_prayer_room/room/user', // GET
        REMOVE_USER_MEMBER : (roomID: number, userID : number) => `global_prayer_room/member/remove-user/${roomID}/${userID}`, // DELETE

        // For the room
        SEARCH_ROOMS: 'global_prayer_room/lists',
        PERSONAL_ROOMS: 'global_prayer_room/personel/rooms',
        CREATE_PERSONAL_ROOM: 'global_prayer_room/create/personel',
        DETAIL_PERSONAL_ROOM: 'global_prayer_room/details/personel/', // GET {id}
        UPDATE_PERSONAL_ROOM: 'global_prayer_room/update/personel/', // GET {id}
        CURRENT_PLAN_PERSONAL: 'global_prayer_room/subscription-plan/personel', // POST
        LEAVE_OR_DELETE : 'global_prayer_room/delete_or_leave_room', // POST

        CHURCH_ROOMS: 'global_prayer_room/church/rooms',
        CREATE_CHURCH_ROOM: 'global_prayer_room/create/church',
        DETAIL_CHURCH_ROOM: 'global_prayer_room/details/personel/', // GET {id}
        UPDATE_CHURCH_ROOM: 'global_prayer_room/update/church/', // GET {id}
        
        PERSONAL_ROOM_USED: 'global_prayer_room/room_used', 
        CHURCH_ROOM_USED: 'global_prayer_room/church/room_used', 

        SELECT_ROOM: (roomID: number) => `global_prayer_room/select_room/${roomID}`, // POST

        // IN APP PURCHASE - SUBSCRIPTION
        IAP_SUBSCRIPTION_VALIDATE : 'plan-purchase/validate', // POST
        ADD_IAP_USER_ID : 'plan-purchase/update', // PUT
    },  

    /* GIVING*/
    GIVING : {
        LIST_FUNDS : 'giving/list_of_funds', // GET
        CREATE_FUND : 'giving/create_fund', // POST
        DETAIL_FUND : 'giving/fund_details', // GET
        STATISTICS_DONATION : (id : number) => `giving/statistic/${id}/donation`, // GET
        EDIT_FUND : (id : number) => `giving/update_fund/${id}`,  // PUT
        CLOSE_FUND : (id : number) => `giving/close_fund/${id}`,  // PUT
        DELETE_MEDIA_FUND : (mediaID : number ) => `giving/delete_media/${mediaID}`,
        
        HISTORY : 'giving/transaction_history', // GET
        DONATION_PAYMENT_PAYPAL : (fundId : number) => `giving/donation/${fundId}`, // POST
        DONATION_SUBSCRIPTION_UPDATE : 'giving/update_subscription', // POST
        DONATION_ONEOFF_UPDATE : 'giving/update_oneoff_donation', // POST
        DONATION_HISTORY_PER_FUND : (fundId : number) => `giving/transaction_report-history/${fundId}`, // GET
        DONATION_TRANSACTION_GRAPH : 'giving/total-transaction-amount-funds', // GET
        LIST_OF_DONORS : 'giving/donors', // GET
        DONATION_ONEOFF_CAPTURE: 'giving/capture_oneoff_donation',
    },

    GLOBALPRAYERUPDATE : {
        SLIDER_GLOBAL_UPDATE : 'global-prayer/global-updates' // GET
    },

    /* MEDIA & RESOURCES */
    RESOURCES : {
        LIST_RESOURCES : 'media-resources/resources', // GET
        LANG : 'media-resources/resources/lang', // GET
        LSIT_CATEGORY : 'media-resources/category/list-category', // GET
        CREATE_CATEGORY : 'superadmin/media-resources/category/create-category', // POST
        CREATE_RESOURCE : 'superadmin/media-resources/create', // POST
        UPLOAD_FILE : 'superadmin/media-resources/file/upload', // POST
        RESOURCE_DETAILS : 'media-resources/resources', // GET
        UPDATE_RESOURCE : 'superadmin/media-resources/resources/update', // PUT
        UPDATE_RESOURCE_STATUS : 'superadmin/media-resources/resources/update/status', // PUT
    },

    /* BLESS CHALLENGE */
    BLESS_CHALLENGE : {
        START_BLESS_CHALLENGE : 'prayforall/bless-challenge/start', // POST
        SAVE_DAILY_CHALLENGE : (id : number) => `prayforall/bless-challenge/save-daily-challenge/${id}`, // POST
        GET_DATE_CONTENT : (id : number) => `prayforall/bless-challenge/${id}`, // GET
        SET_DAILY_REMINDER : (id : number) => `prayforall/bless-challenge/set-daily-reminder/${id}`, // POST
        SET_DAILY_MESSAGE : (id : number) => `prayforall/bless-challenge/save-daily-message/${id}`, // POST
    },

    YOUTUBE_VIDEO : {
        LIST : 'prayforall/youtube-video'
    },

    BLESS_CHALLENGE_VIDEO : {
        VIDEO_HP : 'prayforall/bless-challenge-video', // GET
        ADD_OR_UPDATE : 'superadmin/bless-challenge-video/add-update', // POST
    },

    /* BLESS CHALLENGE NOTIFICATION */
    BLESS_CHALLENGE_NOTIFICATION : {
        LIST : (language : string) => `bless-daily-notification/load/${language}`, // GET 
        SAVE : (language : string) => `bless-daily-notification/save/${language}`, // POST
    }
}